var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerpoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:#d24726;}.cls-3{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PowerPoint_48x1_5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ppt_48",
    "data-name": "ppt 48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32,
    y: 12,
    width: 35,
    height: 47,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,13V58H33V13H66m0-2H33a2,2,0,0,0-2,2V58a2,2,0,0,0,2,2H66a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35,
    y: 44,
    width: 24,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35,
    y: 50,
    width: 24,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46,21A10,10,0,1,0,56,31H46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48,19V29H58A10,10,0,0,0,48,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42,4,4,11V61l38,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,35V27.5l1.55-.16a5.37,5.37,0,0,1,1.71.18,2.84,2.84,0,0,1,2,1.9,5.3,5.3,0,0,1,.25,1.72,5.63,5.63,0,0,1-.25,1.77,3.19,3.19,0,0,1-.75,1.26,3.12,3.12,0,0,1-1.24.76,5.34,5.34,0,0,1-1.71.25L20,35m2.4-12.05L15,23.37V47.75L20,48V39.5l2,0a11.51,11.51,0,0,0,1.92-.12,9.08,9.08,0,0,0,1.74-.44,7.81,7.81,0,0,0,2.9-1.84,8,8,0,0,0,1-1.29,7.9,7.9,0,0,0,.75-1.48,8.78,8.78,0,0,0,.45-1.66,11.87,11.87,0,0,0-.4-5.47,6.09,6.09,0,0,0-1.64-2.52,6.37,6.37,0,0,0-2.68-1.4,11.66,11.66,0,0,0-3.65-.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpoint);
export default __webpack_public_path__ + "static/media/powerpoint.6947dbcdd941e53651bd2b701c2266d7.svg";
export { ForwardRef as ReactComponent };